import { render } from "./StudyListView.vue?vue&type=template&id=50210dae&scoped=true"
import script from "./StudyListView.vue?vue&type=script&lang=js"
export * from "./StudyListView.vue?vue&type=script&lang=js"

import "./StudyListView.vue?vue&type=style&index=0&id=50210dae&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50210dae"]])

export default __exports__